import { z } from "@/helpers/forms/zod";

export const ClientReferenceBlocSchema = z.object({
  clientReference: z.string(),
});

export type InferredClientReferenceBlocSchema = z.infer<
  typeof ClientReferenceBlocSchema
>;
